import React from 'react';
import { connect } from 'react-redux';
import { Form, Input, Select, Tree, Row, Col, message,Button } from 'antd';
import ModalDom from '../../../../components/Modal';
import DetailTitle from '../../../../components/DetailTitle';
import { post, postFrom, config } from '../../../../axios';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import {dicRoleStatus, roleHouseStatusMap} from '../../../../axios/dictionaries';
import TextArea from 'antd/lib/input/TextArea';
import {authKeyFn} from '../../../../axios/authKey'

const Option = Select.Option;
const { TreeNode } = Tree;

class Page extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            data: {},
            title: '新增岗位',
            id: '',
            inputWidth: 260,
            jurisdictionData: [],
            checkedKeys: [], //选中的房源
            isAdmin:false
        }
    }

    render() {
        let { visible, form: { getFieldDecorator } } = this.props;
        let { loading, 
            data, 
            title, 
            inputWidth,
            jurisdictionData,
            checkedKeys,
            isAdmin
         } = this.state;
         const footer = () =>  {
            return(
                isAdmin == 1 ? <div> <Button onClick={this.handleCancel}>取消</Button></div> : null
            )
        }
        const {  getFieldValue } = this.props.form
        const labelValue = getFieldValue('roleHouseStatusList')
        return <ModalDom
            title={title}
            visible={visible}
            loading={loading}
            width={"800px"}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
            footer ={footer()}
        >
            <div className="custom" style={{
                marginTop:'-18px'
            }}>
                <Form
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                    className="min-height"
                >
                    <Row>
                        <Col span={24}>
                            <DetailTitle title="基本信息" />
                            <CustomRow>
                                <CustomCol label="岗位名称">
                                    {getFieldDecorator('name', {
                                        rules: [{
                                            required: true, message: '请输入岗位名称',
                                        }],
                                        initialValue: data.name
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>
                           
                            <CustomRow divider>
                                <CustomCol label="使用状态">
                                    {getFieldDecorator('status', {
                                        rules: [{
                                            required: true, message: '请选择使用状态',
                                        }],
                                        initialValue: data.status || 1
                                    })(
                                        <Select
                                            showSearch
                                            
                                            placeholder="请选择使用"
                                            optionFilterProp={'children'}
                                        >
                                            {dicRoleStatus.map((item, index) => <Option key={index} value={item.value}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol  colStyle={{width: 500}} label="管辖房源状态">
                                    {getFieldDecorator('roleHouseStatusList', {
                                        rules: [{
                                            required: true, message: '请选择管辖房源状态',
                                        }],
                                        initialValue: data.roleHouseStatusList || []
                                    })(
                                        <Select
                                            mode="multiple"
                                            tokenSeparators={[',']}
                                            placeholder="请选择管辖房源状态"
                                        >
                                            {
                                                labelValue && labelValue.length > 5 ?
                                                    [] :
                                                    roleHouseStatusMap.map((item, index) => <Select.Option key={ item.value } value={ item.value }>{ item.title }</Select.Option>)
                                            }
                                        </Select>
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol labelStyle={{ height: '100px' }} height="100px" required={'none'} label="说明">
                                    {getFieldDecorator('remark', {
                                        rules: [{
                                            required: false,
                                            message: '请输入说明',
                                        }],
                                        initialValue: data.remark
                                    })(
                                        <TextArea
                                            rows={3}
                                            cols={10}
                                            placeholder={'请输入'}
                                            style={{ width: inputWidth, height: '100px' }}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>

                        </Col>
                    </Row>

                     <DetailTitle title="分配权限"/>
                {
                    !isAdmin
                        ? <Tree
                        loadData={this.onLoadData}
                        multiple={true}
                        checkable={true}
                        onCheck={
                            (checkedKeys) => {
                                this.setState({ checkedKeys });
                            }
                        }
                        style={{
                            maxHeight: "48vh",
                            overflowY: "scroll"
                        }}
                        checkedKeys={checkedKeys}
                        defaultExpandAll
                    >
                        {this.renderTreeNodes(jurisdictionData)}
                    </Tree>
                    : <div style={{ textAlign: 'center' }}>已拥有全部权限</div>
                    }
                </Form>
            </div>
        </ModalDom>
    }

    componentDidMount() {
        this.props.onRef(this)
        let menusAuth = this.props.config.auth.menusAuth,
            newAuthKey =  authKeyFn(menusAuth);

        this.setState({
            jurisdictionData:newAuthKey
        })
    }

    handleCancel = () => {
        this.props.handleCancel();
        this.setState({ data: {}, loading: false,isAdmin:false, title: "新增岗位", checkedKeys: [] })
    }

    loadPack = ({ id }) => {
        this.setState({ loading: true, title: "编辑岗位", id });
        let data = { roleId: id, owner: this.props.owner };
        postFrom({
            url: config.API_role_getById,
            data,
        }).then(res => {
            let checkedKeys = [];

            res.rightStr && (checkedKeys = res.rightStr.split(','))
            this.setState({ data: res, loading: false,isAdmin:res.isAdmin, checkedKeys });
            
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        })
    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {

            if (!error) {
                this.setState({ loading: true });
                let data = {},
                    NOW_URL = '',
                    responText = '',
                    { checkedKeys } = this.state;

                values.rightStr = checkedKeys.join();
                data = Object.assign({}, values, { owner: this.props.owner, merchantId: '0', isAdmin: "0" });

                if (this.props.handlecreateOrEdit) {
                    NOW_URL = config.API_role_edit;
                    responText = '编辑';
                    data.id = this.state.id;
                } else {
                    NOW_URL = config.API_role_create;
                    responText = '新增'
                }

                post({
                    url: NOW_URL,
                    data,
                }).then(res => {
                    this.setState({ loading: false, checkedKeys: [] });
                    this.props.handleGetList();
                    this.handleCancel();
                    message.success(`${responText}成功`);
                }).catch(err => {
                    message.error(err.message || '获取列表失败');
                    this.setState({ loading: false });
                });

            }
        })
    }
    
    renderTreeNodes = data => {
        return data.map(item => {
            if (item.children) {
                return (
                    <TreeNode selectable={false} title={item.name} key={item.code} dataRef={item}>
                        {this.renderTreeNodes(item.children)}
                    </TreeNode>
                );
            }
            return <TreeNode selectable={false} title={item.name} key={item.code} dataRef={item} />;
        })
    }
}

const mapStateToProps = state => {
    return state
};

export default connect(mapStateToProps)(Form.create()(Page));


// WEBPACK FOOTER //
// ./src/page/Employee/components/RoleAdd/index.js